import {
  GET_BILLING,
  GET_BILLABLE_SUMMARY,
  GET_BILLABLE_PATIENT,
  EXPORT_BILLABLE_CSV,
  CREATE_BILL,
} from '../constants'
import { BillStatus } from '../services'

export function getBilling(
  size: number,
  page: number,
  resolve: any,
  reject: any,
) {
  return { type: GET_BILLING, size, page, resolve, reject }
}

export function getBillablePatient(
  page: number,
  limit: number,
  status: BillStatus,
  search: string,
  resolve: any,
  reject: any,
) {
  return {
    type: GET_BILLABLE_PATIENT,
    page,
    limit,
    status,
    search,
    resolve,
    reject,
  }
}

export function exportBillableCsv(
  search: string,
  resolve: any,
  reject: any,
) {
  return { type: EXPORT_BILLABLE_CSV, search, resolve, reject }
}

export function getBillableSummary(resolve: any, reject: any) {
  return { type: GET_BILLABLE_SUMMARY, resolve, reject }
}

export function createBill(patientId: number, resolve: any, reject: any) {
  return { type: CREATE_BILL, patientId, resolve, reject }
}
